import HomePages from './HomePages';

export default class Home extends HomePages {
  constructor() {
    super();
  }
}

new Home();
